import React, { Component } from 'react';
import { Button, Modal, Input, Form, DatePicker } from 'antd';
import styles from './api-access-settings.module.sass';
import moment from 'moment-timezone';

class DetailsModal extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }
  handleSubmit = async () => {
    const ref = this.form.current;
    try {
      await ref.validateFields();
      const data = this.form.current?.getFieldsValue();

      if (data?.expires_at) {
        const expiresAtISODateTime = data?.expires_at.toISOString();
        // const expiresAtISODateTime = data?.expires_at.toISOString().replace('Z','');
        const finalDataObject = { ...data, expires_at: expiresAtISODateTime };
        this.props.onSubmit(finalDataObject);
      } else {
        this.props.onSubmit(data);
      }

      this.form.current.resetFields();
    } catch (e) {}
  };

  render() {
    const { show, selectedAPIKey } = this.props;
    if (!show) return null;
    return (
      <Modal
        title={selectedAPIKey ? 'Update API Key' : 'Create API Key'}
        className={styles.modal}
        visible
        onCancel={this.props.onCancel}
        footer={[
          <Button key="cancel" onClick={this.props.onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleSubmit}>
            {selectedAPIKey ? 'Update' : 'Create'}
          </Button>,
        ]}
      >
        <Form
          layout="vertical"
          ref={this.form}
          initialValues={{
            api_key_name: selectedAPIKey?.api_key_name,
            expires_at: selectedAPIKey
              ? moment.utc(selectedAPIKey.expires_at)
              : '',
          }}
        >
          <Form.Item label="Nickname" name="api_key_name">
            <Input />
          </Form.Item>
          <Form.Item
            label="Expiration"
            name="expires_at"
            rules={[
              {
                required: true,
                message: 'Please select an expiration date for your API key!',
              },
            ]}
          >
            <DatePicker
              disabledDate={(date) => {
                return date.isBefore(moment());
              }}
              format="YYYY-MM-DD"
              colorText={'red'}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default DetailsModal;
